import axios from 'axios';
import { isSuccess } from '~/utils/api';
// import { getSocketId } from './socket';

console.log('REACT_APP_API_URL', process.env.REACT_APP_API_URL);

const apiAxiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    },
});

// Add a request interceptor
apiAxiosClient.interceptors.request.use(
    function (config) {
        try {
            const accessToken = localStorage.getItem('accessToken');
            if (accessToken && config && config.headers) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            // const socketId = getSocketId();
            // // console.log('socketId', socketId);
            // if (socketId) {
            //     config.headers.socketId = socketId;
            // }
            return config;
        } catch (error) {
            return config;
        }
    },
    function (error) {
        // Do something with request error
        console.log('error', error);
        return Promise.reject(error);
    },
);

function refreshToken() {
    // console.log('refreshToken()');
    return apiAxiosClient.post('/api/auth/get-new-access-token', {
        username: localStorage.getItem('username'),
        browserId: localStorage.getItem('browserId'),
        refreshToken: localStorage.getItem('refreshToken'),
    });
}

// Add a response interceptor
apiAxiosClient.interceptors.response.use(
    function (response) {
        // console.log('response', response);
        if (response && response.data && response.data.code === 94) {
            // Access Token expired
            return refreshToken()
                .then((res) => {
                    // console.log('res of refreshToken()', res.data);
                    if (isSuccess(res)) {
                        const { accessToken } = res.data;
                        localStorage.setItem('accessToken', accessToken);
                        const config = response.config;
                        // if (accessToken && config && config.headers) {
                        //     config.headers.Authorization = `Bearer ${accessToken}`;
                        // }
                        // --> ko cần set access token mới vì thực chất gọi lại từ đầu,
                        // nên sẽ đọc access token từ local storage
                        return apiAxiosClient(config); // gọi lại api gọi lỗi Access Token expired
                    } else {
                        // console.log('Co bao gio vao day khong? 2');

                        localStorage.removeItem('username');
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('refreshToken');
                        // window.location.href = '/login';
                        // --> ko cần vì PrivateRoutes đã thực hiện
                    }
                    return response.data;
                })
                .catch((error) => {
                    console.log('error', error);
                    return response.data;
                });
        }
        if (response && response.data && response.data.code === 92) {
            // Refresh Token expired
            // tách biệt 2 mã Token expired để ko rơi vào vòng lặp vô tận
            // console.log('Co bao gio vao day khong? 1'); // --> vào đây trước, cái 2 sau
        }
        return response.data;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    },
);

export default apiAxiosClient;
